import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const GET_STUDIO_INVITATION_STATUS =
  `${BASE_URL}/rest/v1.0/studio/{studioOwnerName}/invites/{performerUsername}`;
